/**
 * 웹 한정 대결 모드의 시도 카운터 (ADR-028). 도전 판 + 재도전 1회 = 총 2회.
 * localStorage 이고 우회는 막지 않는다 — 부정 방지가 아니라 **설치 이유**다.
 */
export const DUEL_WEB_ATTEMPTS = 2;

export interface DuelStore {
  read(key: string): number;
  write(key: string, n: number): void;
}

export const duelKey = (sessionSeed: string, runIndex: number): string =>
  `ajae.duel.${sessionSeed}.${runIndex}`;

export function localDuelStore(): DuelStore {
  return {
    read(key) {
      try {
        const n = Number(localStorage.getItem(key));
        return Number.isInteger(n) && n >= 0 ? n : 0;
      } catch {
        return 0;
      }
    },
    write(key, n) {
      try {
        localStorage.setItem(key, String(n));
      } catch {
        /* 파티션·프라이빗 모드 — 카운터 없이 진행 */
      }
    },
  };
}

/** 남은 시도 수. 0 이면 "앱에서 계속". */
export function attemptsLeft(store: DuelStore, key: string, max = DUEL_WEB_ATTEMPTS): number {
  return Math.max(0, max - store.read(key));
}

export function consumeAttempt(store: DuelStore, key: string): void {
  store.write(key, store.read(key) + 1);
}
